'use client';
import { motion } from 'framer-motion';
import { XYCHART_HOVER_TRANSITION_MS } from './xychart-constants';
import type { XYChartLinePathNodeInput } from './useXYChartLinePathLengths';
import type { XYChartSeriesLayout } from './xychart-types';
export interface XYChartAnimatedLinePathProps {
    series: XYChartSeriesLayout;
    measuredLength: number;
    hasMeasured: boolean;
    seriesOpacity: number;
    onLinePathNode: (input: XYChartLinePathNodeInput) => void;
}
export function XYChartAnimatedLinePath({ series, measuredLength, hasMeasured, seriesOpacity, onLinePathNode, }: XYChartAnimatedLinePathProps) {
    return (
    <motion.path data-el="Cmarkdownxychart/AnimatedLinePath/Track" ref={(node) => {
            onLinePathNode({ seriesIndex: series.seriesIndex, node });
        }} d={series.linePath} fill="none" stroke={series.color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" strokeDasharray={hasMeasured ? measuredLength : undefined} strokeDashoffset={hasMeasured ? measuredLength : undefined} initial={hasMeasured ? { strokeDashoffset: measuredLength } : undefined} animate={hasMeasured ? { strokeDashoffset: 0 } : undefined} transition={{ duration: 0.7, delay: 0.15, ease: 'easeOut' }} style={{
            opacity: seriesOpacity,
            transition: `opacity ${XYCHART_HOVER_TRANSITION_MS}ms ease-out`,
            pointerEvents: 'none',
        }}/>
    );
}
